
import { useContext, createContext, useState } from "react";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {

  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("site") || "");

  const loginAction = async (data) => {
    try {
      // const response = await fetch("your-api-endpoint/auth/login", {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      //   body: JSON.stringify(data),
      // });
      // const res = await response.json();
      if (true) {
        setUser(data.email);
        setToken(data.email);
        localStorage.setItem("site", data.email);
        window.location.href = "/admin";
        console.log("success")
        return;
      }
      
      // if (true) {
      //   setUser(res.data.user);
      //   setToken(res.token);
      //   localStorage.setItem("site", res.token);
      //   navigate("/admin");
      //   return;
      // }
    } catch (err) {
      console.error(err);
    }
  };

  const logOut = () => {
    console.log("logout");
    setUser(null);
    setToken("");
    localStorage.removeItem("site");
    console.log("logout");
    window.location.href = "/login";  // Using window.location instead of navigate
  };

  return (
    <AuthContext.Provider value={{ token, user, loginAction, logOut }}>
      {children}
    </AuthContext.Provider>
  );

};

export default AuthProvider;

export const useAuth = () => {
  return useContext(AuthContext);
};

